const MissionSection = () => {
  return (
    <section id="mission" className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div className="w-full h-[320px] md:h-[380px] rounded-lg overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/4dbcc0d44f02b6d1bdf0c985c168357c.jpg"
              alt="我々のミッション"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div>
            <p className="text-[#3d6b4f] text-xs font-semibold tracking-widest uppercase mb-3">Our Mission</p>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">我々のミッション</h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-4">
              人と人が出会うことで生まれる可能性を私たちは信じています。もっともっと様々な出会いが生まれほしい。
            </p>
            <p className="text-gray-600 text-sm leading-relaxed mb-4">
              現在世の中には様々なマッチングプラットフォームがありますが、どのサービスも質より量に重きをおいており、本当に会いたい人に会うには大変な苦労（コスト）を伴います。これでは出会いはなかなか広がらない。
            </p>
            <p className="text-gray-600 text-sm leading-relaxed">
              私達は「あなたの探している"会いたい人"を探してくる」ことで、出会う為のコストを下げ、質を高め、社会に対して出会いと可能性を提供し続けます。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
